import { RUGBY_URBA_12_MATCHES } from '../../vs-unified/data/matches/matches-urba-12';

export const applyFieldLogic = (fieldKey: string, value: any, formData: any): Record<string, any> => {
  const updates: Record<string, any> = {};

  // Autocompletar date cuando se selecciona team2
  if (fieldKey === 'team2' && value) {
    const { round, team1 } = formData;

    const match = RUGBY_URBA_12_MATCHES.find(m => m.round === round && m.team1 === team1 && m.team2 === value);

    if (match && !formData.date) {
      updates.date = match.date;
    }
  }

  return updates;
};
